import {useEffect, useState} from "react";
import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, pad} from '../theme';
import cx from '../../../app/editor/utils/makeCls';
import {isDef} from '../../../app/editor/utils/types';
import ColorPicker from "../ColorPicker";
import LabelField from "../LabelField";

const getValue = (value) => isDef(value) ? value : '';

export default function ColorField({className, value, label, size = 'm', placeholder, onChange}) {
    const [stateValue, setStateValue] = useState(getValue(value));

    useEffect(() => {
        setStateValue(getValue(value));
    }, [value]);

    const handleChange = (value, partial) => {
        onChange?.(value, partial);
    };

    const handleKeyDown = (ev) => {
        switch (ev.key) {
            case 'Escape':
                return setStateValue(value);
            case 'Enter':
                return handleChange(stateValue);
        }
    };

    const handleBlur = (ev) => {
        handleChange(stateValue);
    }

    return (
        <div className={cx(className)}>
            {!!label && <LabelField size={size}>{label}</LabelField>}
            <Grid className={cx(
                cl.bg, cl.br, br.b, br.rnd,
                size === 'm' && pad.xy,
                size === 's' && 'px-3 py-1',
            )} items="center" space="s">
                <GridItem>
                    <ColorPicker value={value} onChange={onChange}/>
                </GridItem>
                <GridItem grow>
                    <input
                        className={cx('w-full focus:outline-none', cl.bgTr)}
                        value={stateValue}
                        onChange={ev => setStateValue(ev.target.value)}
                        placeholder={placeholder}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                    />
                </GridItem>
            </Grid>
        </div>
    );
}